<template lang="pug">
  div.tko-tariff
    div.body.body-table
      div.table-choose-panel
        div.toolbar-table
          div.select Тариф, в рублях/ куб.м.
          div.toolbar.toolbar--modal
            div.line
              div.search
              div.actions-panel
                e-button-delete(@click="deleteLastTariffCol").actions-panel__button.btn-delete
                e-button-add(@click="showModalSmallTarif = !showModalSmallTarif")

        div.table.tscroll#tarif
          table.enable-input-border
            thead
              tr
                th Наименование
                template(v-for="tkoOperatorTariff, key in tkoOperatorTariffsByTariffId")
                  th(v-if="+key === 1" v-for="item, index in tkoOperatorTariff") {{item.year}}/{{item.part==1 ? 'II' : 'I'}}
            tbody
              tr(v-for="tkoOperatorTariff, index in tkoOperatorTariffsByTariffId")
                td {{TARIFFS[index].label}}
                td(v-for="item, index in tkoOperatorTariff")
                  input(
                    type="text"
                    v-model="item.value"
                  )
                  // small {{item.year}}/{{item.part==1 ? 'II' : 'I'}}
              tr(v-if="Object.keys(tkoOperatorTariffsByTariffId).length < 1"
                v-for="TARIFF, index in TARIFFS")
                td {{TARIFF.label}}
                td

        div(
          v-if="!hideCalc"
        ).actions-panel
          button(
            @click="downloadTariffCalculationsFile"
            style="width: auto;color: white;"
          ).actions-panel__button.btn-blue Расчёт тарифа объекта методом инвестированного капитала
    e-modal(
      v-if="showModalSmallTarif"
      @close="showModalSmallTarif = false"
      @confirm="addNewTariffRow()"
      title="Добавление новых столбцов"
      :autoHeight="true"
    )
      slot
        div.col
          div.body
            div.col-block
              label Добавить за период
              div.half-block#tarifModal
                label От
                e-select(
                  :model="tariffPeriods"
                  name="from"
                  tabView="tab6"
                  :options="getTariffFromPeriod")
                label До
                e-select(
                  :model="tariffPeriods"
                  name="to"
                  tabView="tab6"
                  :options="getTariffToPeriod"
                )
              span.invalid.error {{addNewTariffRowError}}
</template>

<script>
  import saveFile from '@/utils/saveFile'
  import { calculation } from '@/api/api-endpoints'

  export default {
    name: "tko-tariff",
    data: () => ({
      showModalSmallTarif: false,
      tariffPeriods: {
        from: '',
        to: ''
      },
      addNewTariffRowError: null,
      tkoOperatorTariffsByYearPart: []
    }),
    props: {
      hideCalc: {
        type: Boolean,
        default: false
      },
      entityId: {
        type: [Number, String],
        default: null
      },
      tkoOperatorTariffs: {
        type: Array,
        default: () => ([])
      },
      TARIFFS: {
        type: Object,
        default: () => ({})
      }
    },
    watch: {
      'tkoOperatorTariffs': {
        handler: 'createTkoOperatorTariffsByYearPart',
        immediate: true
      }
    },
    computed: {
      tkoOperatorTariffsByTariffId () {
        // convert
        /* let from = {
          '2011,1': {
            1: {
              ...
            },
            2: {
              ...
            }
          }
        }
        let to = {
          1: {
            '2011,1': {

            }
          },
          2: {
            '2011,1': {

            }
          }
        } */
        // console.log(this.tkoOperatorTariffsByYearPart)
        const tkoOperatorTariffsByYearPart = this.tkoOperatorTariffsByYearPart

        let tariffsByTariffId = {}
        for (let yearPartKey in tkoOperatorTariffsByYearPart) {
          let tmp = tkoOperatorTariffsByYearPart[yearPartKey]
          for (let key in tmp) {
            if (!tariffsByTariffId[key]) {
              tariffsByTariffId[key] = {}
            }
            tariffsByTariffId[key][yearPartKey] = tmp[key]
          }
        }

        // console.log(tariffsByTariffId)
        return tariffsByTariffId
      },
      getLastBiggestYearPart () {
        let last = '2010,0'
        if (this.tkoOperatorTariffsByYearPart) {
          for (let keyPart in this.tkoOperatorTariffsByYearPart) {
            last = keyPart
          }
        }
        return last
      },
      getTariffFromPeriod () {
        return this.generateYearsParts(this.getLastBiggestYearPart, '2050,2')
      },
      getTariffToPeriod () {
        return this.generateYearsParts(this.tariffPeriods.from, '2050,2', true)
        // return this.generateYearsParts(this.tariffPeriods.from, '2050,2')
      }
    },
    methods: {
      createTkoOperatorTariffsByYearPart () {
        console.log('createTkoOperatorTariffsByYearPart')

        let tariffsByYearPart = {}
        let tkoOperatorTariffs = this.tkoOperatorTariffs.slice()

        // sort by year, part
        tkoOperatorTariffs.sort((a, b) => {
          let sumA = `${a.year}${a.part}`
          let sumB = `${b.year}${b.part}`
          if (+sumA < +sumB) {
            return -1
          } else if (+sumA > +sumB) {
            return 1
          }
          return 0
        })

        // genareate by yearpart
        tkoOperatorTariffs.forEach(v => {
          let id = v.year + ',' + v.part
          if (!tariffsByYearPart[id]) {
            tariffsByYearPart[id] = {}
          }
          tariffsByYearPart[id][v.tko_tariff_id] = v
        })

        // create empty models if needed
        for (let key in tariffsByYearPart) {
          let tariffs = tariffsByYearPart[key]
          let year = tariffs[Object.keys(tariffs)[0]].year
          let part = tariffs[Object.keys(tariffs)[0]].part

          for (let TARIFF_KEY in this.TARIFFS) {
            let v = this.TARIFFS[TARIFF_KEY]
            if (!tariffs[v.id]) {
              tariffs[v.id] = {
                value: 0,
                tko_tariff_id: v.id,
                year: year,
                part: part
              }
            }
          }
        }

        this.tkoOperatorTariffsByYearPart = Object.assign({}, tariffsByYearPart)
      },
      deleteLastTariffCol () {
        this.$e.confirmBox('', 'Удалить последнюю колонку?', 'Да').then(() => {
          const keys = Object.keys(this.tkoOperatorTariffsByYearPart)
          const last = keys[keys.length - 1]
          delete this.tkoOperatorTariffsByYearPart[last]

          this.tkoOperatorTariffsByYearPart = Object.assign({}, this.tkoOperatorTariffsByYearPart)
        })
      },
      downloadTariffCalculationsFile() {
        if (!this.entityId) {
          return
        }
        this.$bar.start();
        this.$store.dispatch('downloadFile', {
          endpoint: this.getCalcDownloadEndpoint()
        }).then(r => {
          this.$bar.finish();
          saveFile({
            blob: r.request.response,
            headers: r.headers
          })
        }).catch(e => {
          this.$bar.finish();
          this.$e.errorBox(e)
        })
      },
      parseYear (from, to) {
        return {
          fromYear: from.split(',')[0],
          fromPart: +from.split(',')[1],
          toYear: +to.split(',')[0],
          toPart: +to.split(',')[1]
        }
      },
      generateYearsParts (from, to, putCurrent) {
        let {fromYear, fromPart, toYear} = this.parseYear(from, to)

        if (!fromYear) {
          return []
        }

        let tmp = []
        if (putCurrent) {
          if (fromPart === 1) {
            tmp.push({id: `${fromYear},${fromPart}`, name: `${fromYear}, 2 полугодие`})
          } else {
            tmp.push({id: `${fromYear},${fromPart}`, name: `${fromYear}, 1 полугодие`})
          }
        }

        let skipFirst = false
        if (fromPart === 1) {
          fromYear = +fromYear + 1
        } else {
          skipFirst = true
        }

        for (let i = fromYear; i < toYear; i++) {
          if (skipFirst === false) {
            tmp.push({id: `${i},0`, name: `${i}, 1 полугодие`})
          } else {
            skipFirst = false
          }
          tmp.push({id: `${i},1`, name: `${i}, 2 полугодие`})
        }

        return tmp
      },
      addNewTariffRow () {
        this.addNewTariffRowError = null
        let {fromYear, fromPart, toYear, toPart} = this.parseYear(this.tariffPeriods.from, this.tariffPeriods.to)

        if (!toYear || !fromYear || (toYear < fromYear) || (toYear === fromYear && toPart <= fromPart)) {
          this.addNewTariffRowError = 'Укажите первый и второй кварталы'
          return false
        }

        let len = ((toYear - fromYear) * 2) + 1
        let year = fromYear
        let start = 1
        if (fromPart === 1) {
          start = 2
        }
        if (toPart === 1) {
          len = len + 1
        }
        for (let i = start; i <= len; i++) {
          let part = 1
          if (i & 1) {
            part = 0
          }

          let id = year + ',' + part
          if (!this.tkoOperatorTariffsByYearPart[id]) {
            this.tkoOperatorTariffsByYearPart[id] = {}
          }
          for (let TARIFF_KEY in this.TARIFFS) {
            let v = this.TARIFFS[TARIFF_KEY]
            if (!this.tkoOperatorTariffsByYearPart[id][v.id]) {
              this.tkoOperatorTariffsByYearPart[id][v.id] = {
                value: 0,
                tko_tariff_id: v.id,
                year: year,
                part: part
              }
            }
          }

          if (part === 1) {
            year++
          }
        }

        this.tkoOperatorTariffsByYearPart = Object.assign({}, this.tkoOperatorTariffsByYearPart)

        this.tariffPeriods.from = ''
        this.tariffPeriods.to = ''
        this.showModalSmallTarif = false
      },
      getTariffsArr () {
        const tkoOperatorTariffsByYearPart = this.tkoOperatorTariffsByYearPart

        let tmp = []
        for (let yearPart in tkoOperatorTariffsByYearPart) {
          let v = tkoOperatorTariffsByYearPart[yearPart]
          for (let tariffId in v) {
            tmp.push(tkoOperatorTariffsByYearPart[yearPart][tariffId])
          }
        }
        return tmp
      },
      getCalcDownloadEndpoint() {
        return calculation.indexMethodTariffTko(this.entityId)
      }
    }
  }
</script>
